import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'
import { Edits } from '../../../interfaces/editing/Edits'
import { PeriodReportData } from '../fetchData/queries/PeriodReportData'

type ProjektprognosEditingContextProviderProps = {
  children: ReactNode
}

type ProjektprognosEditingContextStates = {
  edits: Edits
  setEdits: Dispatch<SetStateAction<Edits>>

  editingEnabled: boolean
  setEditingEnabled: Dispatch<SetStateAction<boolean>>
  readOnlyMode: boolean
  setReadOnlyMode: Dispatch<SetStateAction<boolean>>
  snapshotMode: boolean
  setSnapshotMode: Dispatch<SetStateAction<boolean>>

  emptyRowsHiddenToggle: boolean
  setEmptyRowsHiddenToggle: Dispatch<SetStateAction<boolean>>
  prognosisShifted: boolean
  setPrognosisShifted: Dispatch<SetStateAction<boolean>>
  selectedSnapshotId: string
  setSelectedSnapshotId: Dispatch<SetStateAction<string>>

  selectedPeriodReport: PeriodReportData | null
  setSelectedPeriodReport: Dispatch<SetStateAction<PeriodReportData | null>>

  easterEggMode: boolean
  setEasterEggMode: Dispatch<SetStateAction<boolean>>
}

export const ProjektprognosEditingContext =
  createContext<ProjektprognosEditingContextStates | null>(null)

export const ProjektprognosEditingContextProvider = ({
  children,
}: ProjektprognosEditingContextProviderProps) => {
  const [edits, setEdits] = useState<Edits>({
    columns: {},
    budgets: {},
    comments: {},
    projectAttributes: {},
  })
  const [editingEnabled, setEditingEnabled] = useState<boolean>(false) // permission
  const [readOnlyMode, setReadOnlyMode] = useState<boolean>(false) // interaction
  const [snapshotMode, setSnapshotMode] = useState<boolean>(false)
  const [emptyRowsHiddenToggle, setEmptyRowsHiddenToggle] =
    useState<boolean>(true)
  const [prognosisShifted, setPrognosisShifted] = useState<boolean>(false)
  const [selectedSnapshotId, setSelectedSnapshotId] = useState<string>(
    'aktuell projektekonomi'
  )
  const [selectedPeriodReport, setSelectedPeriodReport] =
    useState<PeriodReportData | null>(null)

  const [easterEggMode, setEasterEggMode] = useState<boolean>(false)

  const value: ProjektprognosEditingContextStates = {
    edits,
    setEdits,

    editingEnabled,
    setEditingEnabled,
    readOnlyMode,
    setReadOnlyMode,
    snapshotMode,
    setSnapshotMode,

    emptyRowsHiddenToggle,
    setEmptyRowsHiddenToggle,
    prognosisShifted,
    setPrognosisShifted,
    selectedSnapshotId,
    setSelectedSnapshotId,

    selectedPeriodReport,
    setSelectedPeriodReport,

    easterEggMode,
    setEasterEggMode,
  }

  return (
    <ProjektprognosEditingContext.Provider value={value}>
      {children}
    </ProjektprognosEditingContext.Provider>
  )
}

export const useProjektprognosEditingContext = () => {
  const context = useContext(ProjektprognosEditingContext)

  if (!context) {
    throw Error(
      'useProjektprognosEditingContext must be used within a ProjektprognosEditingContextProvider'
    )
  }

  return context
}
